import {useMutation, useQuery} from "react-query"
import defaultAxios from "lib/http/http.common"
import {ApiResponse} from "dto/ApiResponse"
import {Group, GroupUpdateCommand} from "dto/Group"
import {queryClient} from "index"
import {User} from "dto/User"

const FindAllGroupsQuery = "findAllGroups"
const FindGroupByIdQuery = "findGroupById"
const FindGroupMembersQuery = "findGroupMembers"
export const useFindAllGroups = () => {
    return useQuery([FindAllGroupsQuery], async () => {
        const response = await defaultAxios.get<ApiResponse<Group[]>>("/group")
        return response.data?.body
    })
}

export const useFindGroupById = (id?: string) => {
    return useQuery([FindGroupByIdQuery], async () => {
        const response = await defaultAxios.get<ApiResponse<Group>>(`group/${id}`)
        return response.data?.body
    }, {
        enabled: !!id
    })
}

export const useFindGroupMembers = (id?: string) => {
    return useQuery([FindGroupMembersQuery], async () => {
        const response = await defaultAxios.get<ApiResponse<User[]>>(`group/${id}/members`)
        return response.data?.body
    }, {
        enabled: !!id
    })
}

export const useRegisterGroup = () => {
    return useMutation(async (group: Group | GroupUpdateCommand) => {
        await defaultAxios.post("/group", group)
        await queryClient.invalidateQueries(FindAllGroupsQuery)
    })
}

export const useUpdateGroup = () => {
    return useMutation(async (group: Group) => {
        await defaultAxios.put("/group", group)
        await queryClient.invalidateQueries(FindAllGroupsQuery)
        await queryClient.invalidateQueries(FindGroupByIdQuery)
    })
}

export const useUpdateGroupRoleMapping = () => {
    return useMutation(async ({groupId, roleName}: { groupId: string, roleName: string }) => {
        await defaultAxios.post(`/group/${groupId}/role-mapping/${roleName}`)
        await queryClient.invalidateQueries(FindAllGroupsQuery)
        await queryClient.invalidateQueries(FindGroupByIdQuery)
    })
}

export const useRemoveGroupRoleMapping = () => {
    return useMutation(async ({groupId, roleName}: { groupId: string, roleName: string }) => {
        await defaultAxios.delete(`/group/${groupId}/role-mapping/${roleName}`)
        await queryClient.invalidateQueries(FindAllGroupsQuery)
        await queryClient.invalidateQueries(FindGroupByIdQuery)
    })
}

export const useDeleteGroup = () => {
    return useMutation(async (id: string) => {
        await defaultAxios.delete(`/group/${id}`)
        await queryClient.invalidateQueries(FindAllGroupsQuery)
        await queryClient.invalidateQueries(FindGroupByIdQuery)
    })
}